export default __webpack_public_path__ + "static/media/ppt3_intro.bc5b5d86.png";